<template>
	<div class="main" v-title data-title="零部件联系" style="overflow-x: hidden;">
		<iHeader :message="msg"></iHeader>
		<div class="logo-text">
			<div class="text-1350">
				<a href="/" class="contLogo"><img src="../../assets/partlogo.jpg" fit="scale-down" /></a>
				<div class="textinfo">
					<!-- <p class="font18 bold">品牌名称</p> -->
					<p style="margin-top: 10px;">公司名称:石家庄沐风网络科技有限公司</p>
					<p style="display:  inline-flex;"><span style="width: 70px;">品牌简介: </span><span style="    width: 1330px;
    display: block;">沐风零部件是一家工厂自动化零部件一站式采购平台，为各零部件厂商提供产品展示和销售平台，为设备生产企业提供专业的选型、采购服务，以节省采购成本、提高设计效率，缩短交期，快速实现多赢，为中国制造添砖加瓦。</span></p>
				</div>
				<ul class="curhand">
					<li @click="handleClick(0)" :class="temp==0?'conActive':''">
						<span>联系方式</span>
					</li>
					<!-- <li @click="handleClick(1)" :class="temp==1?'conActive':''">
						<span>品牌介绍</span>
					</li> -->
				</ul>
			</div>
		</div>
		<div class="flexRow justBetween barprebox" style="height: 580px;">
			<div class="barprebox bgwhite mt10 txl">
				<div class="ml20 pd20 mt10" v-if="temp==0">
					<div class="mt10">
						<div class="font13"><span class="textcont"><i class="iconfont icon-shouhuodizhi"></i>地址：</span>石家庄市桥西区中华南大街380号</div>
						<el-divider class="contantD"></el-divider>
						<div class="font13"><span class="textcont"><i class="iconfont icon-web__kefudianhua"></i>客服电话：</span>18633017975</div>
						<el-divider class="contantD"></el-divider>
						<div class="font13"><span class="textcont"><i class="iconfont icon-zuoji"></i>公司座机：</span>0311-85232959</div>
						<el-divider class="contantD"></el-divider>
						<div class="font13"><span class="textcont"><i class="iconfont icon-youxiang"></i>邮箱地址：</span>fuwu@mfcad.com</div>
						<el-divider class="contantD"></el-divider>
						<div class="font13"><span class="textcont"><i class="iconfont icon-guanwangfangwen"></i>官 网：</span><a href="/"
							 target="_blank" class="textcontA">https://www.mfcad.cn/</a></div>
						<el-divider class="contantD"></el-divider>
						<div class="font13"><span class="textcont"><i class="iconfont icon-qq"></i>客服QQ：</span>3356096612</div>
						<el-divider class="contantD"></el-divider>
						<div class="font13"><span class="textcont"><i class="iconfont icon-weixin"></i>客服微信：</span>
							<img src="../../assets/wx.jpg" fit="scale-down" class="contImg" />
							<span>企业微信：</span>
							<img src="../../assets/cwx.jpg" fit="scale-down" class="contImg" />
						</div>
						<el-divider class="contantD"></el-divider>
						<!-- <div class="font13"><span class="textcont"><i class="iconfont icon-xiaochengxu"></i>小程序：</span></div>
						<el-divider class="contantD"></el-divider> -->
					</div>
				</div>

				<div class="ml20 pd20 mt10" v-if="temp==1">
					<div class=" font14 lin-h20">
						沐风零部件是石家庄沐风网络科技有限公司旗下的工厂自动化零部件选型采购平台，旨在企业的工程师、设计师提供产品快速选型服务，为采购人员提供更加方便的一站式采购服务，和为技术人员提供更加全面的产品技术资料。
						沐风零部件依托沐风网强大的品牌影响力，以每日111访问量为基础、111位设计师为支撑，汇集全球61个国家，9000+个工业品牌的20余万类产品，涵盖机械传动、液压气动、流体管道、工业五金、电子电气、设备仪器等在内的16大类，14000+个小类。
						是目前国内最大的工业零配件一站式服务平台。如需了解更加确切的产品参数、PDF样本、CAD模型、技术参数、产品交期、样品价格和批量价格，请通过页面右侧的快捷通道与客服联系，或拨打我们客服热线：0311-85232959
					</div>
					<div class="font14 bold mt25">我们的愿景</div>
					<div class="font14 lin-h20 mt10">
						沐风零部件一站式进货平台希望通过重塑工业品销售产业链，实现资源社会化共享和整个产业链的增值，
						为合作伙伴降低运营成本，打造强势渠道以及快速扩大销售份额的高速发展平台，并通过在线3D智能预览技术、
						智能选型、供应链综合服务等方面扶持合作伙伴快速成长；在工业品市场上，顺应生产力的要求，打破信息壁垒，
						让工业品的交易变得更简单，更放心，更透明。对传统工业品交易的变革，运用电商思维整合资源，重塑交易和服务模式，
						梳理品牌商，服务商和终端用户的三方关系。让交易透明，价格公开，采购过程简单清晰。
					</div>
					<div class="font14 bold mt25">我们的目标</div>
					<div class="font14 lin-h20 mt10">
						打造供应商、终端客户与合作伙伴共同受益的产业链生态系统，并通过复合式创新体制全面扶持平台参与者持续发展，
						最终打造一个“阳光透明，共赢致远”的企业集群生态圈。
					</div>
				</div>

			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
		},
		data() {
			return {
				msg: "contact",
				activeName: 'first',
				temp: 0
			};
		},
		created() {

		},
		methods: {
			handleClick(t) {
				this.temp = t
			},
		},

	}
</script>

<style scoped>
	ul {
		padding: 0px;
		margin: 0px;
	}

	ul li {
		list-style: none;
		display: inline-block;
		/* 	border-bottom: 1px solid #ccc; */
		height: 55px;
		line-height: 55px;
		width: 70px;
		text-align: center;
		margin-right: 20px;
	}
    ul li:hover{
		color:#0144b7 ;
	}
	.conActive {
		border-bottom: 2px solid #0144b7;
	}

	.logo-text {
		width: 100%;
		margin: 0px auto;
		background: #fff;
		/* height: 130px; */
		box-shadow: 0px 2px 10px #d4d3d3;
		border-bottom: 1px solid #ccc;
	}

	.tabcont {
		padding: 20px 30px;
	}

	.contLogo {
		text-align: left;
		/* float: left; */
	}

	.textcont {
		width: 100px;
		-moz-text-align-last: justify;
		text-align-last: justify;
		display: inline-block;
		font-size: 13px;
		margin-right: 10px;
	}

	.textcontA {
		color: #000000;
	}

	.textcontA:hover {
		color: #0144b7
	}

	.contImg {
		width:150px;
		height: 150px;
		vertical-align: middle;
	}

	.text-1350 {
		width: 1350px;
		margin: 0px auto;
		padding-top: 30px;
		text-align: left;
	}

	.textinfo {
		/* width: 400px; */
		display: inline-block;
		text-align: left;
		margin-left: 20px;
		/* float: left; */
		line-height: 25px;
	}

	.icon-shouhuodizhi,
	.icon-web__kefudianhua,
	.icon-zuoji,
	.icon-youxiang,
	.icon-guanwangfangwen,
	.icon-qq,
	.icon-weixin,
	.icon-xiaochengxu {
		font-size: 24px;
		vertical-align: middle;
		margin-right: 10px;
		color: #a0a0a0
	}

	.contantD.el-divider--horizontal {
		margin: 10px 0;
	}

	.cs_top-nav {
		width: 100%;
		padding-top: 12px;
		display: flex;
		background: #ffffff;
	}

	.cs_top-nav-item {
		height: 96px;
		flex: 1;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #333333;
		font-size: 16px;
	}

	.active {
		color: #0090ff;
	}

	.active::after {
		position: absolute;
		bottom: 0;
		left: 50%;
		margin-left: -32px;
		content: '';
		width: 64px;
		height: 4px;
		background: #0090ff;
		border-radius: 2px;
	}

	.cs_mid-content {
		margin-top: 16px;
		width: 100%;
		display: flex;
		flex-direction: column;
		background: #ffffff;
	}

	.cs_content-item {
		height: 120px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 32px;
		box-sizing: border-box;
		margin-left: 32px;
		border-bottom: 1px solid #EEEEEE;
	}
</style>
<style>
	.tabcont .el-tabs__content {
		text-align: left;
	}

	.tabcont .el-tabs__item.is-active {
		color: #0144b7;
	}

	.tabcont .el-tabs__item:hover {
		color: #0144b7;
	}

	.tabcont .el-tabs__active-bar {
		background-color: #003ebc;
	}
</style>



// WEBPACK FOOTER //
// src/pages/notice/contact.vue